import { render, staticRenderFns } from "./OverallStatistics.vue?vue&type=template&id=1d459c8d"
import script from "./OverallStatistics.vue?vue&type=script&lang=js"
export * from "./OverallStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports